import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';

import { LanguageService } from '@ninety/platform/services/services/language.service';

import { selectBos, selectCompanyId } from '../company/company-state.selectors';
import { NotificationActions } from '../notifications/notification.actions';

import { LanguageActions } from './language.actions';

@Injectable()
export class LanguageEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly languageService = inject(LanguageService);

  /** Company Settings / Our Language */
  updateCurrentCompanyCustomLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LanguageActions.updateCurrentCompanyLanguage),
      concatLatestFrom(() => this.store.select(selectBos)),
      switchMap(([{ companyLanguage }, bos]) =>
        this.languageService.updateCustomLanguage(companyLanguage, bos).pipe(
          map(() => LanguageActions.updateCurrentCompanyLanguageSuccess({ companyLanguage })),
          catchError((error: unknown) => of(LanguageActions.updateCustomLanguageFailure({ error })))
        )
      )
    )
  );

  getResetLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LanguageActions.getResetLanguage),
      concatLatestFrom(() => [this.store.select(selectCompanyId)]),
      switchMap(([_, companyId]) =>
        this.languageService.fetchCompanyResetLanguage(companyId).pipe(
          map(resetLanguage => LanguageActions.setResetLanguage({ resetLanguage })),
          catchError((error: unknown) =>
            of(NotificationActions.notifyError({ error, message: 'Failed to get the reset language' }))
          )
        )
      )
    )
  );
}
